const SpinnerSmall = (props) => (
  <div className="spinner-border-sm spinner-border text-danger" />
);

export default SpinnerSmall;
